import { useEffect } from "react";

// Google Ads "Click to call" conversion (click-based). Uses the already
// installed base tag AW-18404975088 — never loads gtag.js itself.
const SEND_TO = "AW-18404975088/GAmnCLqVs-gcEPDDlshE";

export const CallConversionTracker = () => {
  useEffect(() => {
    const onClick = (e) => {
      const el = e.target instanceof Element ? e.target : null;
      const a = el ? el.closest('a[href^="tel:"]') : null;
      if (!a) return;
      if (window.location.pathname.startsWith("/admin")) return;
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", { send_to: SEND_TO, value: 1.0, currency: "INR" });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
  return null;
};

export default CallConversionTracker;
